// extracted by mini-css-extract-plugin
export default {"error":"InfoPage_error__y5tNX","error_heading":"InfoPage_error_heading__Q-q0+","error_reason":"InfoPage_error_reason__UaOoN","error_description":"InfoPage_error_description__YNXMS"};